import styled from "@emotion/styled";
import {
  BACKGROUND_LIGHT,
  GHOST_BACKGROUND,
  OLD_BLUE,
  TERTIARY_GREY,
} from "src/constants/colors";

export const Container = styled.div`
  border-bottom: 1px solid rgba(228, 231, 236, 1);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 0px -34px;
  padding: 16px 34px;
  width: 100%;
`;

export const Breadcrumb = styled.div`
  background-color: rgba(243, 245, 248, 1);
  border-radius: 8px;
  color: rgba(74, 84, 102, 1);
  display: inline-flex;
  align-items: center;
  gap: 10px;
  max-width: 100%;
  min-height: 24px;
  font-size: 12px;
  padding: 4px 8px;
  flex-shrink: 1;
  min-width: 0;
`;

export const BreadcrumbTrail = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  white-space: nowrap;
`;

export const DeleteInviteContainer = styled.div`
  display: flex;
  flex-drection: row;
  align-items: center;
  gap: 8px;
`;

export const ModalWrapper = styled.div<{ isOpen: boolean }>`
  display: ${({ isOpen }) => (isOpen ? "flex" : "none")};
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background-color: #33333399;
  backdrop-filter: blur(10px);
`;

export const Modal = styled.div`
  display: flex;
  flex-direction: column;
  width: 350px;
  border-radius: 8px;
  gap: 34px;
  background-color: ${BACKGROUND_LIGHT};
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e4e7ec;
  padding: 16px 24px;
`;

export const ModalBody = styled.div`
  display: flex;
  padding: 0 24px;
  gap: 8px;
  line-height: 27px;
  letter-spacing: -0.096px;
`;

export const ModalButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 0px 24px 24px 24px;
  gap: 16px;
`;

export const CloseWrapper = styled.div`
  display: flex;
  align-items: center;
  border-radius: 18px;
  padding: 4px;
  background: transparent;
  cursor: pointer;
  color: ${TERTIARY_GREY};

  &:hover {
    background: ${GHOST_BACKGROUND};
    color: ${OLD_BLUE};
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
`;
